(ns ui.view.card.risks.model
  (:require [clojure.string :as string]
            [common.util :as cu]))

(defn delete-risk-confirmation-modal-id
  [{:keys [card-state-path] :as _ctx}]
  (str
   (->> card-state-path
        (mapv (fn [part]
                (if (keyword? part)
                  (cu/kw->str part)
                  part)))
        (string/join "-"))
   "-delete-risk-confirmation-modal"))
